export function isAgentOutputValid(output) {
  try {
    const json = JSON.parse(output);
    return !!(json.answer || json.answer_list);
  } catch {
    return false;
  }
}
